export const SP_PER_EXTRACTION = 500_000;

// SCC surcharge (%) on market sales at player structures
export const STRUCTURE_SCC_SURCHARGE = 0.5;

export const EXTRACTOR_NES_TIERS = [
  { qty: 1,  plex: 120 },
  { qty: 10, plex: 1200 },
  { qty: 50, plex: 5600 },
];

export const TYPE_ID_LARGE_SKILL_INJECTOR = 40520;
export const TYPE_ID_SKILL_EXTRACTOR = 40519;
